module.exports = __webpack_public_path__ + "img/new_artwork_promotion_email_mobile.e7df173c.png";